/**
 * Returns a possessive name.
 *
 * @param {String} name
 * @returns String
 */
export const getPossessiveName = (name: string) =>
  name?.slice(-1) === "s" ? `${name}'` : `${name}'s`;
